export default __webpack_public_path__ + "static/media/email-box.39fe2c99.svg";